export function isBoardEvent<T>(object: unknown): object is T {
  return typeof object === 'object' && object !== null && 'board' in object;
}
